import { createAction, props, union } from '@ngrx/store';
import { SharedPageTypeEnum } from 'src/app/shared/navigation/page-type.enum';
import { MafLtcRemoveQueryI } from 'src/app/api/maf-ltc-remove/maf-ltc-remove-query.int';
import { MafLtcRemoveResponseI } from 'src/app/api/maf-ltc-remove/maf-ltc-remove-result.int';
/* eslint-disable max-len */

export const error = createAction('[LTC / Remove] Error', props<{
  messageText: string;
  pageType: SharedPageTypeEnum;
}>());
export const reset = createAction('[LTC / Remove] Reset', props<{
  pageType: SharedPageTypeEnum;
}>());
export const load = createAction('[LTC / Remove] Get', props<{
  query: MafLtcRemoveQueryI;
  pageType: SharedPageTypeEnum;
}>());
export const received = createAction('[LTC / Remove] Received', props<{
  data: MafLtcRemoveResponseI;
  pageType: SharedPageTypeEnum;
}>());

const all = union({
  error,
  load,
  received,
  reset,
});
export type Actions = typeof all;
